import React, { useState, useEffect } from 'react';

export default function Timer(props) {

    const [duration, setDuration] = useState(null)

    useEffect(() => {
        let timer = {};
        configureTime();
        timer = (setInterval(() => {
            configureTime()
        }, props.paused ? 100000000000 : 1000
        ))

        return () => {
            clearInterval(timer);
            setDuration(null);
        }
    }, [props.startTime]);

    const configureTime = () => {
        var s = (new Date() - new Date(props.startTime));
        function pad(number) {
            if (number < 10) {
                return number = "0" + String(number);
            }
            else {
                return number = String(number);
            }
        }

        var ms = s % 1000;
        s = (s - ms) / 1000;
        var secs = s % 60;
        s = (s - secs) / 60;
        var mins = s % 60;
        s = (s - mins) / 60;
        var hrs = s % 24;
        s = (s - hrs) / 24;

        if (hrs > 0) {
            setDuration(pad(hrs) + ':' + pad(mins) + ':' + pad(secs));

        }
        else {
            setDuration(pad(mins) + ':' + pad(secs));
        }

    }

    return <div>{duration}</div>
}

